// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-agents-container {
  padding-top: 80px;
}
.featured-agents-container .header {
  flex-direction: column;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  gap: 8px;
}
.featured-agents-container .header > p {
  margin: 0;
}
.featured-agents-container .header .back-button {
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #2a2a2a;
  position: absolute;
  left: 0;
  transition: 0.2s ease-in-out;
}
.featured-agents-container .header .back-button:hover {
  color: var(--primary-color-1);
}
.featured-agents-container .grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(10, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  position: relative;
  animation: fadeIn 1s;
}
.featured-agents-container .grid-container .filters, .featured-agents-container .grid-container .agents {
  position: relative;
  height: 100%;
}
.featured-agents-container .grid-container .filters {
  grid-area: 1/1/3/2;
  width: 100%;
}
.featured-agents-container .grid-container .filters ::-webkit-scrollbar {
  width: 5px;
  opacity: 0;
}
.featured-agents-container .grid-container .filters:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.featured-agents-container .grid-container .filters:hover ::-webkit-scrollbar {
  opacity: 1;
}
.featured-agents-container .grid-container .filters:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.featured-agents-container .grid-container .filters:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.featured-agents-container .grid-container .filters:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.featured-agents-container .grid-container .filters .grid-listings-container, .featured-agents-container .grid-container .filters .list-listings-container {
  animation: fadeIn 1s;
}
.featured-agents-container .grid-container .filters .contents {
  padding: 0 140px;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.featured-agents-container .grid-container .filters .contents .filter-block .header {
  display: flex;
}
.featured-agents-container .grid-container .filters .contents .filter-block .header svg {
  margin-right: 10px;
}
.featured-agents-container .grid-container .filters .contents .filter-block .header p {
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.featured-agents-container .grid-container .filters .contents .filter-block .max-min-input {
  display: flex;
  height: 45px;
  align-items: center;
}
.featured-agents-container .grid-container .filters .contents .filter-block .max-min-input input {
  height: 45px;
  width: 250px;
}
.featured-agents-container .grid-container .filters .contents .filter-block .max-min-input input:disabled {
  background-color: var(--secondary-color-4);
}
.featured-agents-container .grid-container .filters .contents .filter-block .max-min-input .separator {
  padding: 0 10px;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  color: var(--secondary-color-2);
}
.featured-agents-container .grid-container .filters .contents .filter-block .type-choices {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.featured-agents-container .grid-container .filters .contents .filter-block .type-choices > div.choice {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  height: 45px;
  width: 150px;
  margin-right: 20px;
  border: 0.8000000119px solid #BEBEBE;
  border-radius: 10px;
  color: var(--secondary-color-1);
  background-color: white;
  cursor: pointer;
  transition: 0.3s;
}
.featured-agents-container .grid-container .filters .contents .filter-block .type-choices > div.choice:hover {
  opacity: 0.75;
}
.featured-agents-container .grid-container .filters .contents .filter-block .type-choices > div.choice.selected {
  border-color: var(--primary-color-1);
  background-color: #FEF9E8;
  color: var(--primary-color-1);
}
.featured-agents-container .grid-container .filters .contents .filter-block .type-choices > div.choice > p {
  font-size: 16px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
}
.featured-agents-container .agents {
  width: 100%;
  overflow: hidden;
}
.featured-agents-container .agents ::-webkit-scrollbar {
  width: 5px;
  opacity: 0;
}
.featured-agents-container .agents:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.featured-agents-container .agents:hover ::-webkit-scrollbar {
  opacity: 1;
}
.featured-agents-container .agents:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.featured-agents-container .agents:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.featured-agents-container .agents:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.featured-agents-container .agents .contents {
  min-height: calc(100vh - 190px);
  height: 100%;
  padding-top: 40px;
}
.featured-agents-container .agents .contents p.no-result {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: var(--secondary-color-5);
  animation: fadeIn 1s;
}
.featured-agents-container .agents .contents .loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.863);
  z-index: 2;
  display: flex;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/ShowingBeeAgent/showingBeeAgent.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAAI;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAER;AADQ;EACI,SAAA;AAGZ;AADQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,4BAAA;AAGZ;AAFY;EACI,6BAAA;AAIhB;AAAI;EACI,aAAA;EACA,0BAAA;EACA,mCAAA;EACA,oBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,oBAAA;AACR;AAAQ;EACI,kBAAA;EACA,YAAA;AAEZ;AACQ;EACI,kBAAA;EACA,WAAA;AACZ;AAAY;EACI,UAAA;EACA,UAAA;AAEhB;AAAY;EAII,UAAA;EAIA,WAAA;EAKA,oBAAA;AARhB;AAJgB;EACI,UAAA;AAMpB;AAHgB;EACI,mBAAA;AAKpB;AAFgB;EACI,mBAAA;EACA,mBAAA;AAIpB;AADgB;EACI,mBAAA;AAGpB;AAAY;EACI,oBAAA;AAEhB;AAAY;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAEhB;AAAoB;EACI,aAAA;AAExB;AADwB;EAAM,kBAAA;AAI9B;AAHwB;EACI,uCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAK5B;AAFoB;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AAIxB;AAHwB;EACI,YAAA;EACA,YAAA;AAK5B;AAJ4B;EACI,0CAAA;AAMhC;AAHwB;EACI,eAAA;EACA,eAAA;EACA,iCAAA;EACA,+BAAA;AAK5B;AAFoB;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AAIxB;AAHwB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,+BAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAK5B;AAH4B;EAAU,aAAA;AAMtC;AAL4B;EACI,oCAAA;EACA,yBAAA;EACA,6BAAA;AAOhC;AAL4B;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;AAOhC;AACI;EAEI,WAAA;EACA,gBAAA;AAAR;AACQ;EACI,UAAA;EACA,UAAA;AACZ;AACQ;EAII,UAAA;EAIA,WAAA;EAKA,oBAAA;AATZ;AAHY;EACI,UAAA;AAKhB;AAFY;EACI,mBAAA;AAIhB;AADY;EACI,mBAAA;EACA,mBAAA;AAGhB;AAAY;EACI,mBAAA;AAEhB;AACQ;EACI,+BAAA;EACA,YAAA;EACA,iBAAA;AACZ;AAAY;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;AAEhB;AAAY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,aAAA;AAEhB;AAEI;EACI;IAAK,UAAA;EACX;EAAM;IAAO,UAAA;EAGb;AACF","sourcesContent":[".featured-agents-container {\r\n    padding-top: 80px;\r\n    .header {\r\n        flex-direction: column;\r\n        display: flex;\r\n        align-items: center;\r\n        position: relative;\r\n        width: 100%;\r\n        gap: 8px;\r\n        > p {\r\n            margin: 0;\r\n        }\r\n        .back-button {\r\n            cursor: pointer;\r\n            font-size: 16px;\r\n            font-weight: 700;\r\n            color: #2a2a2a;\r\n            position: absolute;\r\n            left: 0;\r\n            transition: .2s ease-in-out;\r\n            &:hover {\r\n                color: var(--primary-color-1);\r\n            }\r\n        }\r\n    }\r\n    .grid-container {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: repeat(10, 1fr);\r\n        grid-column-gap: 0px;\r\n        grid-row-gap: 0px;\r\n        // min-height: 80vh;\r\n        position: relative;\r\n        animation: fadeIn 1s;\r\n        .filters, .agents {\r\n            position: relative;\r\n            height: 100%;\r\n            // position: fixed;\r\n        }\r\n        .filters {\r\n            grid-area: 1 / 1 / 3 / 2;\r\n            width: 100%;\r\n            ::-webkit-scrollbar {\r\n                width: 5px;\r\n                opacity: 0;\r\n            }\r\n            &:hover {\r\n                ::-webkit-scrollbar {\r\n                    opacity: 1;\r\n                }\r\n                /* Track */\r\n                ::-webkit-scrollbar-track {\r\n                    border-radius: 10px;\r\n                }\r\n                /* Handle */\r\n                ::-webkit-scrollbar-thumb {\r\n                    background: #b4b4b4; \r\n                    border-radius: 10px;\r\n                }\r\n                /* Handle on hover */\r\n                ::-webkit-scrollbar-thumb:hover {\r\n                    background: #b4b4b4; \r\n                }\r\n            }\r\n            .grid-listings-container, .list-listings-container {\r\n                animation: fadeIn 1s;\r\n            }\r\n            .contents {\r\n                padding: 0 140px;\r\n                display: flex;\r\n                height: 100%;\r\n                align-items: center;\r\n                justify-content: center;\r\n                .filter-block {\r\n                    .header {\r\n                        display: flex;\r\n                        svg { margin-right: 10px; }\r\n                        p {\r\n                            font-family: 'Proxima Nova', sans-serif;\r\n                            margin: 0;\r\n                            font-size: 14px;\r\n                            font-weight: 700;\r\n                            color: var(--secondary-color-1);\r\n                        }\r\n                    }\r\n                    .max-min-input {\r\n                        display: flex;\r\n                        height: 45px;\r\n                        align-items: center;\r\n                        input {\r\n                            height: 45px;\r\n                            width: 250px;\r\n                            &:disabled {\r\n                                background-color: var(--secondary-color-4);\r\n                            }\r\n                        }\r\n                        .separator {\r\n                            padding: 0 10px;\r\n                            font-size: 14px;\r\n                            font-family: 'Roboto', sans-serif;\r\n                            color: var(--secondary-color-2);\r\n                        }\r\n                    }\r\n                    .type-choices{\r\n                        display: flex;\r\n                        flex-wrap: wrap;\r\n                        justify-content: space-between;\r\n                        > div.choice {\r\n                            flex: none;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            justify-content: center;\r\n                            margin-top: 10px;\r\n                            height: 45px;\r\n                            width: 150px;\r\n                            margin-right: 20px;\r\n                            border: 0.800000011920929px solid #BEBEBE;\r\n                            border-radius: 10px;\r\n                            color: var(--secondary-color-1);\r\n                            background-color: white;\r\n                            cursor: pointer;\r\n                            transition: .3s;\r\n                \r\n                            &:hover { opacity: .75; }\r\n                            &.selected {\r\n                                border-color: var(--primary-color-1);\r\n                                background-color: #FEF9E8;\r\n                                color: var(--primary-color-1);    \r\n                            }\r\n                            > p {\r\n                                font-size: 16px;\r\n                                font-weight: 500;\r\n                                font-family: 'Roboto', sans-serif;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .agents { \r\n        // grid-area: 3 / 1 / 11 / 2;\r\n        width: 100%;\r\n        overflow: hidden;\r\n        ::-webkit-scrollbar {\r\n            width: 5px;\r\n            opacity: 0;\r\n        }\r\n        &:hover {\r\n            ::-webkit-scrollbar {\r\n                opacity: 1;\r\n            }\r\n            /* Track */\r\n            ::-webkit-scrollbar-track {\r\n                border-radius: 10px;\r\n            }\r\n            /* Handle */\r\n            ::-webkit-scrollbar-thumb {\r\n                background: #b4b4b4; \r\n                border-radius: 10px;\r\n            }\r\n            /* Handle on hover */\r\n            ::-webkit-scrollbar-thumb:hover {\r\n                background: #b4b4b4; \r\n            }\r\n        }\r\n        .contents {\r\n            min-height: calc(100vh - 190px);\r\n            height: 100%;\r\n            padding-top: 40px;\r\n            p.no-result {\r\n                font-family: 'Proxima Nova', sans-serif;\r\n                font-weight: 700;\r\n                font-size: 18px;\r\n                text-align: center;\r\n                color: var(--secondary-color-5);\r\n                animation: fadeIn 1s;\r\n            }\r\n            .loader {\r\n                position: absolute;\r\n                left: 0;\r\n                right: 0;\r\n                top: 0;\r\n                bottom: 0;\r\n                background-color: rgba(255, 255, 255, 0.863);\r\n                z-index: 2;\r\n                display: flex;\r\n            }\r\n        }\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
